
import { all, put, takeEvery } from 'redux-saga/effects'
import swal from 'sweetalert'
import actions from './responseHandling.types'

export function* SET_ERROR({ payload, module, act}) {
  try {
    yield put({
      type: "responseHandling/SET_STATE",
      payload: {
        errMsg: payload
      }
    })
    swal(`Error ${act}`, `${module} :: ${payload}`, 'error')
  } catch (err) {
    console.log({ err })
  }
}

export function* SET_SUCCESS({ payload, module, act }) {
  try {
    yield put({
      type: "responseHandling/SET_STATE",
      payload: {
        errMsg: payload
      }
    })
    swal(`Success 
      ${act}`,
      `${module} ${payload}`, 'success')
  } catch (err) {
    console.log({ err })
  }
}

export function* SET_WARNING({ payload, module, act }) {
  try {
    yield put({
      type: "responseHandling/SET_STATE",
      payload: {
        errMsg: payload,
      },
    });
    swal(
      `Info 
      ${act}`,
      `${module} ${payload}`,
      "warning"
    );
  } catch (err) {
    console.log({ err });
  }
}



export default function* rootSaga() {
  yield all([
    takeEvery(actions.SET_ERROR, SET_ERROR),
    takeEvery(actions.SET_SUCCESS, SET_SUCCESS),
     takeEvery(actions.SET_WARNING, SET_WARNING),
  ])
}